// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"1":"dashboard-pages","131":"homepage","983":"report"}[chunkId] || chunkId) + "." + {"1":"63262e8f","131":"fb41400a","532":"b34c1c14","832":"e7c2cc88","983":"68bc8f7b"}[chunkId] + ".chunk.css";
};